// Toggle multicolumn card text expansion

// Delegate click for multicolumn card text expansion
(function() {
  function checkToggleVisibility() {
    document.querySelectorAll('.multicolumn-card__text-wrapper').forEach(function(wrapper) {
      var rte = wrapper.querySelector('.rte');
      var btn = wrapper.querySelector('.multicolumn-card__toggle');
      if (!rte || !btn) return;
      // If content height is less than or equal to visible height (no truncation), hide toggle
      if (rte.scrollHeight <= rte.clientHeight) {
        btn.style.display = 'none';
      }
    });
  }

  // Run on DOMContentLoaded or immediately if document loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkToggleVisibility);
  } else {
    checkToggleVisibility();
  }

  document.addEventListener('click', function(event) {
    var toggleBtn = event.target.closest('.multicolumn-card__toggle');
    if (!toggleBtn) return;
    var wrapper = toggleBtn.closest('.multicolumn-card__text-wrapper');
    if (!wrapper) return;
    // Toggle expanded state
    wrapper.classList.toggle('expanded');
    // Swap show more / show less labels
    var showMoreLabel = toggleBtn.querySelector('.label-show-more');
    var showLessLabel = toggleBtn.querySelector('.label-show-less');
    if (showMoreLabel && showLessLabel) {
      showMoreLabel.classList.toggle('hidden');
      showLessLabel.classList.toggle('hidden');
    }
  });
})(); 